import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

interface ChartProps {
    data: Array<number>,
    labels: Array<string>,
    bgColors: Array<string>,
    borderColor: Array<string>,
    position?: "top" | "right" | "left" | "bottom" | "center" | "chartArea",
    alignLabels?: "center" | "start" | "end" | undefined,
    showLegend?: boolean,
    cutout?: string
}

export const DoughnutChart: React.FC<ChartProps> = ({data, labels, bgColors, borderColor, position, alignLabels, showLegend, cutout}) => {

    return (
        <Doughnut 
            data={{
            labels,
            datasets: [
                {
                    label: '# of Votes',
                    data,
                    backgroundColor: bgColors,
                    borderColor,
                    borderWidth: 1,
                },
            ],
            }}
            height="90%"
            width="100%"
            options={{
                maintainAspectRatio: false,
                responsive: true, 
                cutout: cutout || '50%',
                plugins: {
                    legend: {
                        align: alignLabels || 'center',
                        position: position || 'right',
                        display: showLegend,
                        labels: {
                            boxWidth: 16,
                            boxHeight: 16,
                            color: '#111111',
                            usePointStyle: true
                        }
                    }
                },
            }}
        />
    )
}
